import { render, staticRenderFns } from "./Nested.vue?vue&type=template&id=7a5d09c6&scoped=true"
import script from "./Nested.vue?vue&type=script&lang=js"
export * from "./Nested.vue?vue&type=script&lang=js"
import style0 from "./Nested.vue?vue&type=style&index=0&id=7a5d09c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5d09c6",
  null
  
)

export default component.exports